import { getAuthToken } from '@final-commerce/jwt-storage-lib';

interface FetchOptions extends RequestInit {
  headers?: HeadersInit;
}

export const apiFetch = async (url: string, options: FetchOptions = {}): Promise<Response> => {
  const token = await getAuthToken();
  if (!token) {
    throw new Error('No token found');
  }
  return makeRequest(url, options, token);
};

const makeRequest = async (
  url: string,
  options: FetchOptions,
  accessToken: string,
): Promise<Response> => {
  const headers: HeadersInit = {
    ...options.headers,
    Authorization: `Bearer ${accessToken}`,
  };
  const fullOptions: RequestInit = { ...options, headers };
  const response = await fetch(url, fullOptions);
  if (!response.ok) {
    const errorBody = await response.json();
    throw new Error(errorBody?.message || 'Error making request');
  }
  return response;
};
